<template>
    <v-toolbar
        id="top-alerts-toolbar"
        dense
        flat
    >
        <v-btn
            icon
            style="width:32px;"
            class="mr-3"
            @click="backNav()"
        >
            <v-icon
                class="material-icons-outlined pa-4"
                :class="$vuetify.breakpoint.smAndUp ? 'back' : ''"
            >
                chevron_left
            </v-icon>
        </v-btn>
        <v-toolbar-title class="pl-0 title">
            <slot />
        </v-toolbar-title>
    </v-toolbar>
</template>
<script>
export default {
    methods: {
        backNav() {
            if (this.$router.currentRoute.path === '/profile') {
                this.$router.push('/tickets');
            } else {
                if (this.$vuetify.breakpoint.xsOnly) {
                    this.$router.push('/profile');
                } else {
                    this.$router.push('/tickets');
                }
            }
        }
    }
};
</script>
<style scoped>
#top-alerts-toolbar {
    border-bottom: 2px solid #eee;
}
.title {
    /* Profile Settings */
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 32px;

    /* identical to box height, or 160% */
    letter-spacing: 0.0025em;

    /* Colors/Black and Grey/Header Text */
    color: #35383F;
}
.back {
    border-radius: 25px;
    background: #F5F7FA;
}
</style>
